var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#141414",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 12c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1c0-4.418278-3.581722-8-8-8s-8 3.581722-8 8 3.581722 8 8 8c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1c-5.5228475 0-10-4.4771525-10-10s4.4771525-10 10-10 10 4.4771525 10 10z",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -5.556349 10.585786)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 13c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h13c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.2928932 9.70710678c-.3905243-.39052429-.3905243-1.02368927 0-1.41421356s1.0236893-.39052429 1.4142136 0l3 2.99999998c.3905243.3905243.3905243 1.0236893 0 1.4142136l-3 3c-.3905243.3905243-1.0236893.3905243-1.4142136 0s-.3905243-1.0236893 0-1.4142136l2.2928932-2.2928932z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.91aab345074051f7a92b9d25192a310a.svg";
export { ForwardRef as ReactComponent };